import { api, endpoint } from "@/api";
import { DataTable } from "@/components";
import { useSearchQuery } from "@/utils/useSearchQuery";
import { flare } from "@flareapp/js";
import { Input, Select, Spin } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { AiOutlineFundView } from "react-icons/ai";
import { FiEdit, FiEye, FiTrash } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const DeviceListOnSiteLocation = ({ siteLocationId }) => {
  const role = useSearchQuery("role");
  const { userDetails } = useSelector((state) => state.user);

  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const [sensorList, setSensorList] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const deleteDevice = async (deviceId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this device?",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`/device/` + deviceId, {
            withCredentials: true,
          })
          .then(() => {
            getSensorList();
            Swal.fire({
              title: "Done!",
              text: "Device Deleted Successfully",
              icon: "info",
              timer: 2000,
              button: false,
            });
          });
      }
    });
  };

  // get sensors
  const getSensorList = async () => {
    try {
      setIsLoading(true);
      let { result, count } = await api.get(endpoint.get_sensor_list + siteLocationId, {
        params: {
          limit,
          page,
          search: search?.trim() || "",
          role: role !== "all" ? role : null,
          status,
        },
      });
      setSensorList(result);
      setTotal(count);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
    setIsLoading(false);
  };

  const searchHandler = (e) => {
    e.preventDefault();
    getSensorList();
  };

  useEffect(() => {
    getSensorList();
  }, [page, limit, search, status]);

  const columns = [
    {
      title: "No.",
      render: (_, __, ind) => (page - 1) * limit + ind + 1,
      width: "60px",
    },
    {
      title: "Device Name",
      render: (_, row) => <p className="m-0">{row?.name || "--"}</p>,
    },
    {
      title: "Device Type",
      render: (_, row) => <p className="m-0">{row?.deviceType?.name || "--"}</p>,
    },
    // {
    //   title: "ApiKey",
    //   render: (_, row) => row?.apiKey,
    // },
    // {
    //   title: "Site Name",
    //   render: (_, row) => <p className="m-0">{row?.site?.name || "--"}</p>,
    // },
    {
      title: "Active Status",
      render: (_, row) => (
        <div>
          {row.status === "active" ? (
            <span className="badge text-bg-success">Online</span>
          ) : (
            <span className="badge text-bg-danger">Offline</span>
          )}
        </div>
      ),
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      width: "220px",
      render: (_, row) => (
        <div>
          {(() => {
            switch (userDetails.role) {
              case "superAdmin":
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-az-primary me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-edit me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-view-gray me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              case "businessAdmin":
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-success me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-info me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              case "installer":
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-success me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-info me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              case "admin":
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-success me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-info me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              case "user":
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-success me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/edit/` + row._id} className="btn btn-info me-1">
                      <FiEdit />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                    <button className="btn btn-danger" onClick={() => deleteDevice(row._id)}>
                      <FiTrash />
                    </button>
                  </div>
                );
              default:
                return (
                  <div className="actions">
                    <Link to={`/devices/details/` + row._id} className="btn btn-success me-1">
                      <FiEye />
                    </Link>
                    <Link to={`/devices/data/` + row._id} className="btn btn-warning me-1">
                      <AiOutlineFundView />
                    </Link>
                  </div>
                );
            }
          })()}
        </div>
      ),
    },
  ];

  return (
    <Spin spinning={isLoading}>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card card-dashboard-six">
            <div className="card-header pb-2">
              <div className="w-100">
                <label className="az-content-label">Device List</label>
                <div className="d-flex mt-2">
                  <Select
                    size="large"
                    style={{ width: "300px" }}
                    value={status || ""}
                    onChange={(value) => {
                      setPage(1);
                      setStatus(value);
                    }}
                  >
                    <option value="">All Status</option>
                    <option value="active">Online</option>
                    <option value="inactive">Offline</option>
                  </Select>
                  <div className="ms-auto">
                    <form onSubmit={searchHandler} className="input-group">
                      <Input
                        size="large"
                        type="search"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => {
                          setPage(1);
                          setSearch(e.target.value);
                        }}
                        // aria-label="search"
                        // className="form-control"
                      />
                      {/* <Button variant="success" type="submit">
                        search
                      </Button> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <DataTable
              dataSource={sensorList}
              columns={columns}
              rowKey={(record) => record.id}
              pagination={{
                defaultPageSize: limit,
                current: page,
                total,
                showSizeChanger: true,
                onShowSizeChange: (_, pageSize) => {
                  setLimit(pageSize);
                },
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                pageSizeOptions: [10, 20, 50],
                responsive: true,
              }}
              onChange={(pagination) => {
                setPage(pagination.current);
              }}
            />
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default DeviceListOnSiteLocation;

DeviceListOnSiteLocation.propTypes = {
  siteLocationId: PropTypes.string,
};
